import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import i18next from 'i18next';
import Icon from '@/components/Common/Icons/Icon';
import * as Icons from '@/components/Common/Icons/Icons';

interface ShipmentPointsProps {
  points: number | undefined;
}

/**
 * ShipmentPoints component renders the ADR points information row
 * for the shipment detail view.
 */
export const ShipmentPoints: React.FC<ShipmentPointsProps> = ({ points }) => {
  return (
    <Grid item xs={12} md={4}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
        <Icon
          svg={Icons.adrMono}
          viewBox="0 0 103.5 103.425"
          fontSize="30px"
          sx={{ mr: 1, color: 'grey' }}
          color="currentColor"
        />
        <Typography variant="subtitle2" sx={{ color: 'grey' }}>
          {i18next.t('common:weightWatcher.adrPoints')}
        </Typography>
      </Box>
      <Typography
        sx={{
          fontWeight: 600,
          color: '#000',
          marginBottom: '10px',
          fontSize: '15px',
        }}
      >
        {points ?? 0}
      </Typography>
    </Grid>
  );
};
